// extracted by mini-css-extract-plugin
module.exports = {"input":"input-m__input__3khl7"};